import React from 'react';
import { Drawer } from 'antd';
import { CreateNewPassengerForm } from './createNewPassengerForm';

interface ICreateNewPassengerDrawerProps {
  visible: boolean;
  onSubmit: (
    result: boolean,
    passenger: { id?: string; email?: string; phone?: string; name?: string },
  ) => any;
  onClose: () => any;
}

const CreateNewPassengerDrawer: React.FC<ICreateNewPassengerDrawerProps> = (
  props: ICreateNewPassengerDrawerProps = {
    visible: false,
    onSubmit: () => {},
    onClose: () => {},
  },
) => {
  const onSubmit = async (
    result: boolean,
    passenger: { id?: string; email?: string; phone?: string; name?: string },
  ) => {
    await props.onSubmit(result, passenger);
  };

  return (
    <Drawer
      title={'Crear nuevo pasajero'}
      width={350}
      visible={props.visible}
      onClose={props.onClose}
      destroyOnClose={true}
    >
      <CreateNewPassengerForm onSubmit={onSubmit} />
    </Drawer>
  );
};

export default CreateNewPassengerDrawer;
